module.exports = __webpack_public_path__ + "img/nmc.c954ce6f.png";